var map = {
	"./gallery-1.jpg": 7344,
	"./gallery-2.jpg": 3983,
	"./gallery-3.jpg": 7602,
	"./gallery-4.jpg": 5649,
	"./gallery-bg.png": 7424,
	"./gallery-five-1.jpg": 1379,
	"./gallery-five-2.jpg": 1332,
	"./gallery-five-3.jpg": 9377,
	"./gallery-five-4.jpg": 7682,
	"./gallery-four-1.jpg": 1291,
	"./gallery-four-2.jpg": 6124,
	"./gallery-four-3.jpg": 473,
	"./gallery-four-4.jpg": 4730,
	"./gallery-four-5.jpg": 2916,
	"./gallery-four-6.jpg": 4040,
	"./gallery-four-7.jpg": 8869,
	"./gallery-four-8.jpg": 9014,
	"./gallery-three-1.jpg": 8443,
	"./gallery-three-2.jpg": 6924,
	"./gallery-three-3.jpg": 1273,
	"./gallery-three-4.jpg": 5530,
	"./gallery-three-5.jpg": 7687,
	"./gallery-three-6.jpg": 4840,
	"./gallery-three-7.jpg": 6021,
	"./gallery-three-8.jpg": 9814,
	"./gallery-three-9.jpg": 8339,
	"./gallery-two-1.jpg": 8145,
	"./gallery-two-2.jpg": 374,
	"./gallery-two-3.jpg": 8899,
	"./portfolio-details.jpg": 5477,
	"./portfolio-middle-1.jpg": 7250,
	"./portfolio-middle-2.jpg": 5741,
	"./project1.jpg": 1366,
	"./project2.jpg": 977,
	"./project3.jpg": 2932,
	"./project4.jpg": 5663
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9048;